// Components==============
import { faBook } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import destroyProjectGroup from 'actions/project-group/destroy';
import indexProjectGroup from 'actions/project-group/index';
import updateProjectGroup from 'actions/project-group/update';
import indexProject from 'actions/project/index';
import destroyReflection from 'actions/reflection/destroy';
import Avatar from 'components/UI/Avatar/Avatar';
import Button from 'components/UI/Button/Button';
import { usePermission } from 'hooks/usePermission';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import { useHistory } from 'react-router';
import './Invite.module.scss';

// =========================

export default function Invite({
  type,
  user,
  id,
  reflection,
  themeId,
}: {
  type: 'project' | 'reflection';
  user?: UserEntity;
  id?: number;
  reflection?: ReflectionEntity;
  themeId?: number;
}) {
  const dispatch = useReduxAction();
  const history = useHistory();

  const translate = useTranslate();

  const isTeacher = usePermission(['Docent', 'super-admin']);

  const theme =
    useRedux((state) =>
      themeId ? state.theme?.entities.byId[themeId] : undefined
    ) || reflection?.project_process?.theme;

  if (reflection && !reflection.project_process) return <></>;

  const onReject = () => {
    if (type === 'project')
      dispatch(destroyProjectGroup({ id })).then(() => {
        dispatch(indexProject());
        dispatch(indexProjectGroup());
      });

    if (type === 'reflection' && reflection?.id)
      dispatch(destroyReflection(reflection.id));
  };

  const onAccept = () => {
    if (type === 'project')
      dispatch(updateProjectGroup({ id, membership: 'member' })).then(() => {
        dispatch(indexProject());
        dispatch(indexProjectGroup());
      });

    if (type === 'reflection')
      history.push(
        `/groei/reflecteren/${reflection?.project_process?.project_id}/${reflection?.project_process_id}/${reflection?.id}`
      );
  };

  const conUser = user || reflection?.for_user;

  const senderIsTeacher =
    conUser?.roles.map((r) => r.name).includes('Docent') ||
    conUser?.roles.map((r) => r.name).includes('super-admin');

  return (
    <div styleName={`wrapper ${type === 'reflection' ? 'reflection' : ''}`}>
      <h2>
        {type === 'project'
          ? translate(
              `project.collaboration-request.${
                senderIsTeacher ? 'teacher' : 'student'
              }-${isTeacher ? 'teacher' : 'student'}`
            )
          : translate(
              `reflection.reflect-request-${isTeacher ? 'teacher' : 'student'}`
            )}
      </h2>
      <div styleName="items">
        <Avatar user={conUser} />
        <p>
          {conUser?.first_name} {conUser?.last_name}
        </p>
      </div>
      <div styleName="items">
        <FontAwesomeIcon icon={faBook} />
        <p>{theme?.name}</p>
      </div>
      <div styleName="buttons">
        <Button
          onClick={onReject}
          color={`transparent-white-border${reflection ? '-purple' : ''}`}
        >
          {type === 'project'
            ? translate('project.actions.reject-invitation')
            : translate('general.terms.reject')}
        </Button>
        <Button
          onClick={onAccept}
          color={`white-border${reflection ? '-purple' : ''}`}
        >
          {type === 'project'
            ? translate('project.actions.accept-invitation')
            : isTeacher
            ? translate('general.terms.judge')
            : translate('general.terms.reflect')}
        </Button>
      </div>
    </div>
  );
}
